import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const MonthBar = ({ month, onChange, yearsAhead = 3 }) => {
  const now = new Date();
  const minMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const y = month.getFullYear();
  const m = month.getMonth();
  const atMin = new Date(y, m, 1) <= minMonthStart;

  const years = [];
  const startYear = Math.min(now.getFullYear(), y);
  for (let yy = startYear; yy <= now.getFullYear() + yearsAhead; yy += 1) years.push(yy);

  const clamp = (dt) => (dt < minMonthStart ? new Date(minMonthStart) : dt);
  const go = (delta) => onChange(clamp(new Date(y, m + delta, 1)));
  const setMonth = (mm) => onChange(clamp(new Date(y, mm, 1)));
  const setYear = (yy) => onChange(clamp(new Date(yy, m, 1)));

  return (
    <div className="hi-monthbar">
      <button type="button" className="btn ghost" disabled={atMin} onClick={() => go(-1)}><ChevronLeft size={16} /></button>
      <div className="hi-monthbar-sel">
        <select className="inp" value={m} onChange={(e) => setMonth(Number(e.target.value))}>
          {MONTHS.map((name, i) => (
            <option key={i} value={i} disabled={y === now.getFullYear() && i < now.getMonth()}>{name}</option>
          ))}
        </select>
        <select className="inp" value={y} onChange={(e) => setYear(Number(e.target.value))}>
          {years.map((yy) => <option key={yy} value={yy}>{yy}</option>)}
        </select>
      </div>
      <button type="button" className="btn ghost" onClick={() => go(1)}><ChevronRight size={16} /></button>
    </div>
  );
};

export default MonthBar;
